export default __webpack_public_path__ + "static/blob-10-e8c3193756bf71de951bc5cbb1818a00.svg";